
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unpixelate-image",
      function () {
        return require("private-next-pages/unpixelate-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unpixelate-image"])
      });
    }
  